import createResourceImageLifecycleCallbacks from './createResourceImageLifecycleCallbacks';
import type { CategoryResource } from '../../Entities/Category';
import type { MerchantResource } from '../../Entities/Merchant';
import type { ProductResource } from '../../Entities/Product';
import type { BidResource } from '../../Entities/Bid';

export default [
  createResourceImageLifecycleCallbacks<CategoryResource>('categories', 'image_url'),
  createResourceImageLifecycleCallbacks<MerchantResource>('merchants', 'image_url'),
  createResourceImageLifecycleCallbacks<ProductResource>('products', 'image_url'),
  createResourceImageLifecycleCallbacks<BidResource>('bids', 'image_url'),
];
